import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { SITE, NAV_ITEMS } from "../../lib/site";
import NexusLogo from "./NexusLogo";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "backdrop-blur-md bg-black/20"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-[68px] md:h-[76px] flex items-center justify-between">
        <button
          onClick={() => (location.pathname === "/" ? scrollTo("inicio") : navigate("/"))}
          className="flex items-center gap-3 group"
          data-testid="logo-home-link"
        >
          <NexusLogo className="h-7 md:h-8" />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              data-testid={`nav-link-${item.id}`}
              className="nx-btn-ghost text-[13px]"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={SITE.whatsappUrl}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="header-cta-whatsapp"
            className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-2.5 text-[13px] font-medium text-white hover:bg-white/10 transition-colors"
          >
            <MessageCircle size={15} className="text-emerald-300" />
            Fale com a equipe Nexus
          </a>
          <button
            className="lg:hidden p-2 rounded-full border border-white/10 bg-white/5"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Abrir menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                data-testid={`mobile-nav-link-${item.id}`}
                className="text-left text-white/80 hover:text-white px-3 py-3 rounded-lg hover:bg-white/5"
              >
                {item.label}
              </button>
            ))}
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="mobile-cta-whatsapp"
              className="mt-2 nx-btn-primary justify-center"
            >
              <MessageCircle size={16} /> Fale no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
